var _circle, _circle2, _circle3, _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#F0C7C3",
    fillOpacity: 0.18
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 17,
    fill: "#F55254",
    fillOpacity: 0.16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 24,
    r: 8,
    fill: "#F55254"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.418,
    y: 14.2324,
    width: 1.45688,
    height: 5.51302,
    rx: 0.72844,
    transform: "rotate(-57.7475 25.418 14.2324)",
    fill: "#F55254"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7949,
    y: 17.2324,
    width: 1.45688,
    height: 5.51302,
    rx: 0.72844,
    transform: "rotate(-123.027 13.7949 17.2324)",
    fill: "#F55254"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22L20 26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22L24 26",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/Alarm.cc5b1a9fab75dfa60319670872e2f24f.svg";
export { ForwardRef as ReactComponent };